import React, { useState } from "react";
import Layout from "../layout/Layout";
import {
	Form,
	Input,
	Button,
	Radio,
	Flex,
	Typography,
	notification,
} from "antd";
import { MailOutlined, PhoneOutlined, LockOutlined } from "@ant-design/icons";
import axios from "axios";
import { api } from "../utils/Api";

const { Title, Text } = Typography;

const ForgotPassword = ({ history }) => {
	const [loading, setLoading] = useState(false);
	const [method, setMethod] = useState("email");
	const [form] = Form.useForm();
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	// Email validation regex
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	// Phone validation regex
	const phoneRegex =
		/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

	const handleMethodChange = (e) => {
		setMethod(e.target.value);

		// limpiar input al cambiar metodo
		form.setFieldsValue({
			credential: "",
		});
	};

	const getValidationRules = () => {
		if (method === "email") {
			return [
				{
					required: true,
					message: "Please input your email!",
				},
				{
					pattern: emailRegex,
					message: "Please enter a valid email address!",
				},
			];
		}

		return [
			{
				required: true,
				message: "Please input your phone number!",
			},
			{
				pattern: phoneRegex,
				message: "Please enter a valid phone number!",
			},
		];
	};

	const handleSubmit = async (values) => {
		try {
			setLoading(true);

			const body = {
				type: method,
				credential: values.credential,
			};

			const { data } = await axios.post(`${api}/auth/forgot-password`, body);

			if (data.success) {
				openNotification("success", "Success", data.message);

				setTimeout(() => {
					history.push({
						pathname: "/reset-password",
						state: {
							type: method,
							credential: values.credential,
						},
					});
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.log(err);

			const errorMessage =
				err?.response?.data?.message || "Something went wrong.";

			openNotification("error", "Error", errorMessage);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Layout title="" description="" type="small">
			<Flex vertical gap={10}>
				<Title level={3} style={{ textAlign: "center", marginBottom: 0 }}>
					Forgot Password
				</Title>

				<Text
					type="secondary"
					style={{ textAlign: "center", marginBottom: 20 }}
				>
					Select how you want to receive your verification code.
				</Text>

				<Form form={form} layout="vertical" onFinish={handleSubmit}>
					<Form.Item label="Verification Method">
						<Radio.Group
							value={method}
							onChange={handleMethodChange}
							style={{ width: "100%" }}
						>
							<Flex gap={20}>
								<Radio value="email">
									<MailOutlined /> Email
								</Radio>

								<Radio value="phone">
									<PhoneOutlined /> Phone
								</Radio>
							</Flex>
						</Radio.Group>
					</Form.Item>

					<Form.Item
						label={method === "email" ? "Email Address" : "Phone Number"}
						name="credential"
						rules={getValidationRules()}
					>
						<Input
							size="large"
							placeholder={
								method === "email"
									? "Enter your email"
									: "Enter your phone number"
							}
							prefix={method === "email" ? <MailOutlined /> : <PhoneOutlined />}
						/>
					</Form.Item>

					<Form.Item>
						<Button
							type="primary"
							htmlType="submit"
							size="large"
							block
							loading={loading}
							icon={<LockOutlined />}
						>
							Send Verification Code
						</Button>
					</Form.Item>

					<Form.Item style={{ marginBottom: 0 }}>
						<Button type="link" block onClick={() => history.push("/signin")}>
							Back to Sign In
						</Button>
					</Form.Item>
				</Form>
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default ForgotPassword;
